import React, { useState } from "react";
import { renderDifficultyBadge } from "./difficulty";
interface SimilarProductsItemProps {
    Val: { id: number;
    title: string;
    difficulty: number;
    old_price: number | null;
    price: number;
    vat: number;
    slug: string;
    thumbnail: string;
    }
    handleProductItem: (slug: string) => void; // Replace 'number' with the actual type of id
    handlerClose: () => void;
    handlerSimilarProduct: (slug: string) => void; // Replace 'number' with the actual type of id
  }

const SimilarProductsItem: React.FC<SimilarProductsItemProps>  = ({ Val, handleProductItem, handlerClose, handlerSimilarProduct }) => {
    const [valUrlImg, setValUrlImg] = useState(Val.thumbnail)
    const urlImgPlaceholder = "/img/img_placeholder.jpg"
    
    const checkDifficulty = () => renderDifficultyBadge(Val.difficulty);

    // const replaceUrl = () => {
    //     // history.replaceState(null, "", "./");
    //     history.replaceState(null, "", val.slug);
    // }

    // console.log("VALUE URL IMG" + valUrlImg)
    return (
        <div className="col25 inline">
            <div className="product">
                {/* <a className="img openlayer" style={{backgroundImage: `url(${val.thumbnail ? val.thumbnail : "../img/img_placeholder.jpg"})`}} href={`/product/${val.slug}`}></a> */}
                {/* <a className="img openlayer" style={{backgroundImage: `url(${valUrlImg})`}} href={`/product/${val.slug}`}></a> */}
                <a className="img" //openlayer" 
                    // onClick={handlerClose}
                    // onClick={ () => handleProductItem(val.id, val.title, val.slug) }
                    // onClick={ () => {history.replaceState(null, "", val.slug); handleProductItem(val.id, val.title, val.slug)} }
                    // onClick={ () => handlerSimilarProduct(val.id, val.title, val.slug) }
                    onClick={ () => handlerSimilarProduct(Val.slug) }
                >
                        <img 
                            src={valUrlImg}
                            onLoad={() => console.log('Obrázek podobného produktu na detailu produktu se nahrál')} 
                            onError={() => setValUrlImg(urlImgPlaceholder)}
                            alt={Val.title}
                            loading="lazy"
                            width="384"
                            height="512"
                        />
                        {checkDifficulty()}
                </a>
                {/* <a className="img openlayer" style={{backgroundImage: `url(../img/img_placeholder.jpg)`}} href={`/product/${val.slug}`}></a> */}
                <div className="desc">
                    <a className=""//"openlayer" 

                        // onClick={handlerClose}
                        // onClick={ () => {replaceUrl; handleProductItem(val.id, val.title, val.slug)} }
                        onClick={ () => handlerSimilarProduct(Val.slug) }
                    >{Val.title}</a>
                    <span className="amount">{Val.price} Kč</span>
                </div>
            </div>
        </div>            
    )
}

export default SimilarProductsItem;